<div class="{{ containerClass }} border border-ui-separator rounded-sm flex items-stretch">
  @for (item of buttons; track item) {
    @if (!item.hidden) {
      @let itemClasses =
        itemClass +
        ' flex items-center justify-center gap-sm text-txt border-r border-ui-separator last-of-type:border-r-0 cursor-pointer last-of-type:rounded-r-sm first-of-type:rounded-l-sm py-sm px-base text-xs leading-xs sm:text-sm sm:leading-sm';
      @let itemState =
        {
          'bg-primary text-white': selectedButtonValue === item.value,
          'hover:bg-ui-hover': selectedButtonValue !== item.value
        };
      @if (item.link) {
        <!-- Link items are selected by the route via selectedButtonValue, not by the click -->
        <a [routerLink]="item.link" [class]="itemClasses" [ngClass]="itemState">
          <ng-container *ngTemplateOutlet="itemContent; context: { $implicit: item }"></ng-container>
        </a>
      } @else {
        <div
          [class]="itemClasses"
          [ngClass]="itemState"
          (click)="selectedButtonValue = item.value; selectedButtonChanged.emit(item.value)"
        >
          <ng-container *ngTemplateOutlet="itemContent; context: { $implicit: item }"></ng-container>
        </div>
      }
    }
  }
</div>

<ng-template #itemContent let-item>
  @if (item.icon) {
    <div class="flex">
      <svg-icon [key]="item.icon" [class]="iconClass"></svg-icon>
    </div>
  }
  <span>
    {{ item.label }}
  </span>
</ng-template>
